var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaptureQualityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52531 1C8.21386 1 6.93187 1.35791 5.84145 2.02848C4.75102 2.69904 3.90114 3.65214 3.39927 4.76725C2.8974 5.88236 2.76609 7.10939 3.02194 8.29318C3.27779 9.47697 3.90931 10.5644 4.83664 11.4178C5.76397 12.2713 6.94546 12.8525 8.23171 13.088C9.51795 13.3234 10.8512 13.2026 12.0628 12.7407C13.2744 12.2788 14.31 11.4966 15.0386 10.4931C15.7672 9.48948 16.1561 8.3096 16.1561 7.10262C16.1561 5.4841 15.4575 3.93188 14.214 2.78742C12.9705 1.64295 11.2839 1 9.52531 1ZM9.52531 9.71803C8.96326 9.71803 8.41383 9.56464 7.94651 9.27725C7.47918 8.98987 7.11495 8.5814 6.89986 8.10349C6.68478 7.62559 6.6285 7.09972 6.73815 6.59238C6.8478 6.08504 7.11845 5.61902 7.51588 5.25325C7.91331 4.88747 8.41966 4.63838 8.97091 4.53747C9.52215 4.43655 10.0935 4.48834 10.6128 4.6863C11.1321 4.88425 11.5759 5.21947 11.8881 5.64958C12.2004 6.07968 12.3671 6.58534 12.3671 7.10262C12.3671 7.79627 12.0677 8.46151 11.5347 8.95199C11.0018 9.44248 10.279 9.71803 9.52531 9.71803Z",
    fill: "#2CA9BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52486 9.7191C11.0943 9.7191 12.3666 8.54814 12.3666 7.10369C12.3666 5.65924 11.0943 4.48828 9.52486 4.48828C7.9554 4.48828 6.68311 5.65924 6.68311 7.10369C6.68311 8.54814 7.9554 9.7191 9.52486 9.7191Z",
    stroke: "black",
    strokeWidth: 1.66666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64284 10.2109L1 13.6894L3.87018 14.4741L5.65101 16.6884L8.3791 13.1053",
    stroke: "black",
    strokeWidth: 1.66666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4086 10.2109L18.0515 13.6894L15.1813 14.4741L13.4005 16.6884L10.6724 13.1053",
    stroke: "black",
    strokeWidth: 1.66666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1561 7.10262C16.1561 8.3096 15.7672 9.48948 15.0386 10.4931C14.31 11.4966 13.2744 12.2788 12.0628 12.7407C10.8512 13.2026 9.51795 13.3234 8.23171 13.088C6.94546 12.8525 5.76397 12.2713 4.83664 11.4178C3.90931 10.5644 3.27779 9.47697 3.02194 8.29318C2.76609 7.10939 2.8974 5.88236 3.39927 4.76725C3.90114 3.65214 4.75102 2.69904 5.84145 2.02848C6.93187 1.35791 8.21386 1 9.52531 1C11.2839 1 12.9705 1.64295 14.214 2.78742C15.4575 3.93188 16.1561 5.4841 16.1561 7.10262Z",
    stroke: "black",
    strokeWidth: 1.66666,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptureQualityIcon);
export default __webpack_public_path__ + "static/media/captureQualityIcon.e8c6be9149a065820a2f28f6979c22a4.svg";
export { ForwardRef as ReactComponent };